import { render, staticRenderFns } from "./solutionHead.vue?vue&type=template&id=5e308015&scoped=true"
import script from "./solutionHead.vue?vue&type=script&lang=js"
export * from "./solutionHead.vue?vue&type=script&lang=js"
import style0 from "./solutionHead.vue?vue&type=style&index=0&id=5e308015&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e308015",
  null
  
)

export default component.exports